import React from 'react';
import Slider from 'react-slick';
import { Box, Typography, Container, Button, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useVacation } from '../context/VacationContext';
import './Home.css';

function Home() {
  const vacationMode = useVacation();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true
  };

  const slides = [
    {
      image: 'https://images.pexels.com/photos/3998417/pexels-photo-3998417.jpeg',
      title: 'Welcome to Noureddine Barbershop',
      description: 'Professional haircuts and styling'
    },
    {
      image: 'https://images.pexels.com/photos/1570807/pexels-photo-1570807.jpeg',
      title: 'Expert Grooming',
      description: 'Premium grooming services for the modern gentleman'
    },
    {
      image: 'https://images.pexels.com/photos/1805600/pexels-photo-1805600.jpeg',
      title: 'Relaxing Environment',
      description: 'Experience luxury in our modern facility'
    },
    {
      image: 'https://images.pexels.com/photos/897262/pexels-photo-897262.jpeg',
      title: 'Traditional & Modern Styles',
      description: 'Classic techniques with modern trends'
    }
  ];

  return (
    <Box className="home">
      {vacationMode?.active && (
        <Container maxWidth="md" className="appointment-container">
          <Alert severity="info" sx={{
            mb: 3,
            bgcolor: '#f8f9fa',
            border: '1px solid #e9ecef',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            borderRadius: 2,
            p: 2
          }}>
            The barber is currently on vacation from {vacationMode.startDate.toLocaleDateString()} to {vacationMode.endDate.toLocaleDateString()}. 
            Walk-in services are not available during this period. Please check back after {vacationMode.endDate.toLocaleDateString()} or 
            book a regular appointment for a date after the vacation period.
          </Alert>
        </Container>
      )}
      <Box className="carousel-container">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <Box key={index} className="slide">
              <div 
                className="slide-background"
                style={{ backgroundImage: `url(${slide.image})` }}
              />
              <Box className="slide-content">
                <Typography variant="h2" className="slide-title">
                  {slide.title}
                </Typography>
                <Typography variant="h5" className="slide-description">
                  {slide.description}
                </Typography>
                <Button 
                  variant="contained" 
                  color="primary" 
                  size="large"
                  component={Link}
                  to="/appointment"
                  className="book-now-btn"
                >
                  Book Now
                </Button>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>

      <Container maxWidth="lg" className="welcome-section">
        <Typography variant="h3" component="h1" align="center" gutterBottom className="welcome-text">
          Premium Barbershop Experience
        </Typography>
        <Typography variant="h6" align="center" paragraph className="welcome-text">
          Experience the finest in men's grooming at Noureddine Barbershop. 
          Our skilled barbers combine traditional techniques with modern styles 
          to give you the perfect look.
        </Typography>
      </Container>
    </Box>
  );
}

export default Home;
